import { CHART_TYPE } from '../constants';

import {
  ICircularChart,
  PieChart,
  DonutChart,
  SemiCircleChart,
  IBarChart,
  SingleBarChart,
  GroupedBarChart,
  BoxPlotChart,
  StackedBarChart
} from '../models';
import { ILineChart, LineChart } from '../models/line-chart-model';

// TODO: Include all types of charts
type ObjectType<T> = T extends CHART_TYPE.DONUT
  ? DonutChart
  : T extends CHART_TYPE.PIE
  ? PieChart
  : T extends CHART_TYPE.SEMI_CIRCLE
  ? SemiCircleChart
  : T extends CHART_TYPE.SINGLE_BAR
  ? SingleBarChart
  : T extends CHART_TYPE.GROUPED_BAR
  ? GroupedBarChart
  : T extends CHART_TYPE.BOX_PLOT
  ? BoxPlotChart
  : T extends CHART_TYPE.STACKED_BAR
  ? StackedBarChart
  : T extends CHART_TYPE.LINE
  ? LineChart //future types added below
  : never;

// T -> Generic to determine return type
// obj.type -> create object based on data
export const getChartModel = <T extends CHART_TYPE>(
  obj: ICircularChart | IBarChart
): ObjectType<T> => {
  switch (obj?.type) {
    case CHART_TYPE.DONUT:
      return new DonutChart(obj as ICircularChart) as ObjectType<T>;
    case CHART_TYPE.PIE:
      return new PieChart(obj as ICircularChart) as ObjectType<T>;
    case CHART_TYPE.SEMI_CIRCLE:
      return new SemiCircleChart(obj as ICircularChart) as ObjectType<T>; //future types added below
    case CHART_TYPE.SINGLE_BAR:
      return new SingleBarChart(obj as IBarChart) as ObjectType<T>;
    case CHART_TYPE.GROUPED_BAR:
      return new GroupedBarChart(obj as IBarChart) as ObjectType<T>;
    case CHART_TYPE.BOX_PLOT:
      return new BoxPlotChart(obj as IBarChart) as ObjectType<T>;
    case CHART_TYPE.STACKED_BAR:
      return new StackedBarChart(obj as IBarChart) as ObjectType<T>;
    case CHART_TYPE.LINE:
      return new LineChart(obj as ILineChart) as ObjectType<T>;
    default:
      throw new Error('Unknown Chart Type');
  }
};
